import { Box, Typography, Button, CircularProgress } from "@mui/material";
import LightbulbTwoTone from "@mui/icons-material/LightbulbTwoTone";
import ArtifactList from "./List/EvaluationArtifactList";
import NoRecords from "components/NoRecords";
import { useNavigate } from "react-router-dom";
import { BasePathProvider, useBasePath } from "components/Providers";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const EvaluationArtifact = ({ artifactList }) => {
    const navigate = useNavigate();
    const baseUrl = useBasePath();
    const loading = useSelector(state => state.adminEvaluation.artifact.loading);
    const { t } = useTranslation();

    const boxStyles = {
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 2.5,
        display: "flex",
        flexDirection: "column",
        minHeight: "300px",
        maxHeight: "400px",
        overflowY: "auto",
        overflowX: "auto",
    };

    const innerBoxStyles = {
        mt: 2,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
    };

    return (
        <BasePathProvider value={`${baseUrl}`}>
            <Box sx={{ ...boxStyles, flexGrow: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{t('My Artifacts')}</Typography>
                    <Button variant="contained" color="primary" size="small" onClick={() => navigate(`${baseUrl}/artifact/new`)}>
                        {t('Add Artifact')}
                    </Button>
                </Box>
                {loading ? (
                    <Box sx={{ ...innerBoxStyles }}>
                        <CircularProgress size={50} />
                    </Box>
                ) : artifactList?.length > 0 ? (
                    <Box sx={{ ...innerBoxStyles, alignItems: "flex-start" }}>
                        <ArtifactList artifactList={artifactList} />
                    </Box>
                ) : (
                    <Box sx={{ ...innerBoxStyles }}>
                        <NoRecords
                            icon={<LightbulbTwoTone sx={{ fontSize: 50, color: "primary.main" }} />}
                            message={t('No Artifacts Yet')}
                        />
                    </Box>
                )}
            </Box>
        </BasePathProvider>
    );
};

export default EvaluationArtifact;